import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { InventarService } from 'src/app/core/services/inventar.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { ActivityLogComponent } from 'src/app/shared/components/modals/activity-log/activity-log.component';
import { FilialService } from 'src/app/core/services/filial.service';
import { WorkerService } from 'src/app/core/services/worker.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { ICompany } from 'src/app/core/models/company.model';
import { IFilial } from 'src/app/core/models/filial.model';

@Component({
  selector: 'app-inventar-item',
  templateUrl: './inventar-item.component.html',
  styleUrls: ['./inventar-item.component.css'],
})
export class InventarItemComponent implements OnInit {
  @Input() inventar: any;
  @Input() workers: any;
  @Input() isAllIventars: any;
  @Output('onEdit') editInventar = new EventEmitter();
  @Output('onFinish') finishInventar = new EventEmitter();
  @Output('onDelete') deleteInventar = new EventEmitter();
  @Output('onDownloadCsv') downloadCsv = new EventEmitter();
  @Output('onCopyInventar') copyInventar = new EventEmitter();
  @Output() onAssignWorker = new EventEmitter();

  @ViewChild('dialogActivityLog')
  private dialogActivityLog: ActivityLogComponent;

  toggleWorkers = false;
  companyId = '';
  filialId = '';
  assignedWorkers: any;
  selectedInventar;
  currentUser: any;
  selectedWorkerId = '';
  activeLogList = [];
  inventarRouterLink = [];

  constructor(
    private inventarService: InventarService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private filialService: FilialService,
    private workerService: WorkerService,
    private companyService: CompanyService
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
    // this.route.parent.parent.parent.params.subscribe((res) => {
    //   this.companyId = res.id || this.currentUser.companyId;
    // });

    this.filialId =
      this.route.snapshot.params.filialId || this.inventar.filialId;

    this.isAllIventars
      ? (this.inventarRouterLink = [
          '/root',
          'companies',
          this.inventar.filial.companyId,
          'filials',
          this.inventar.filial.id,
          'inventars',
          this.inventar.id,
          'products',
        ])
      : (this.inventarRouterLink = [this.inventar.id, 'products']);
  }

  loadInventarWorkers(inventarId) {
    this.inventarService
      .getFilialInventarWorkers(this.filialId, inventarId)
      .subscribe(
        (res) => {
          this.assignedWorkers = res;
          this.toggleWorkers = true;
        },
        (err) => {}
      );
  }

  onWorkers(inventar) {
    this.selectedInventar = inventar;
    let filial;
    this.loadInventarWorkers(this.selectedInventar.id);
    if (this.isAllIventars) {
        this.workerService.getCompanyWorkers(this.selectedInventar.filial.companyId).subscribe(
          (res) => {
            this.workers = res;
          },
          (err) => {}
        );
    }
  }

  onEdit(inventar) {
    this.editInventar.emit(inventar);
  }
  onFinish(inventar) {
    this.finishInventar.emit(inventar);
  }
  onDelete(inventar) {
    this.deleteInventar.emit(inventar);
  }
  onDownloadCsv(inventar) {
    this.downloadCsv.emit(inventar);
  }

  onCopyInventar(inventar) {
    this.copyInventar.emit(inventar);
  }

  assignWorkerToInventar() {
    this.inventarService
      .assignWorkersToFilialInventar(this.selectedInventar.filialId, this.selectedInventar.id, [
        this.selectedWorkerId,
      ])
      .subscribe(
        (res) => {
          this.toggleWorkers = false;
          this.selectedInventar = null;
          this.selectedWorkerId = '';
          this.toastr.success('Success');
        },
        (err) => {}
      );
  }

  unassignWorker(worker) {
    this.inventarService
      .removeWorkerFromFilialInventar(this.selectedInventar.filialId, this.selectedInventar.id, [
        worker.id,
      ])
      .subscribe(
        (res) => {
          this.toggleWorkers = false;
          this.selectedInventar = null;
          this.selectedWorkerId = '';
          this.toastr.success('Worker has been removed from inventar.');
        },
        (err) => {}
      );
  }

  selectInventar(inventar) {
    this.inventarService.setInventar(inventar);
  }

  async openModalLogActivity(inventar) {
    this.inventarService
      .getIventarActivityLog(this.filialId, inventar.id)
      .subscribe((res) => {
        console.log(res);
        this.activeLogList = res;
      });
    return await this.dialogActivityLog.open();
  }
 
  toggleDetails: boolean = false;;
  filial: IFilial;
  company: ICompany;

  loadFilial(product) {
   this.filialService.getFilialById(product.filial.companyId, product.filial.id).subscribe(res => {
    this.filial = res;
   })
  }

  loadCompany(product) {
    this.companyService.getCompanyById(product.filial.companyId).subscribe(res => {
      this.company = res;
    })
  }

  getDetails(product) {
    this.toggleDetails = true;
    this.loadFilial(product)
    this.loadCompany(product)
  }
}
